import AbstractContext from "../shared/AbstractContext";
import portalConfiguration from "../shared/configuration/PortalConfiguration";
import Admin from "./Admin";
import AdminSession from "./session/AdminSession";

export default class AdminContext extends AbstractContext<AdminContext, AdminSession> {
	private page?: Admin;

	public async initialize(page: Admin) {
		this.page = page;

		this._session = new AdminSession(portalConfiguration.baseUrl, this);

		try {
			await this._session.initialize();
			this._initialized = true;
			this.page.setState({
				context: this
			});
		} catch (exception: any) {
			// can be ignored, Errors are already handled
		}
	}

	public getPage(): Admin {
		return this.page!;
	}
}